"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _form = _interopRequireDefault(require("./form"));
var PolicyIcon = function PolicyIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6 4h12v7.006a1 1 0 1 0 2 0V4a2 2 0 0 0-2-2H5.5C4.668 2 4 2.668 4 3.5v17c0 .832.668 1.5 1.5 1.5h7.028a1 1 0 1 0 0-2H6V4zm2 4a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1zm0 4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1zm11.662 1.89c.733.396 1.36.645 2.06.685.708.04 1.337.616 1.323 1.419-.038 2.296-.31 3.822-.904 4.889-.635 1.14-1.562 1.616-2.44 1.999a1.734 1.734 0 0 1-1.397 0l-.009-.004c-.921-.413-1.834-.92-2.453-2.064-.58-1.07-.837-2.578-.888-4.815v-.005a1.393 1.393 0 0 1 1.324-1.419c.697-.04 1.328-.288 2.066-.681a1.341 1.341 0 0 1 1.318-.004zm-.657 1.914c-.611.308-1.278.579-2.033.704.077 1.815.318 2.78.628 3.353.287.53.675.807 1.404 1.142.716-.319 1.1-.575 1.39-1.094.314-.563.567-1.535.637-3.401-.755-.125-1.419-.396-2.026-.704z"
  }));
};
PolicyIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var config = {
  angConfiguration: {
    typeURL: 'http://anypoint.com/vocabs/digital-repository#MulePolicyAsset',
    assetType: 'MulePolicy'
  },
  owner: {
    gusTeam: 'MS API Manager',
    gusTeamLink: 'https://gus.lightning.force.com/lightning/r/ADM_Scrum_Team__c/a00AH000000in0RYAQ/view'
  },
  name: 'Policy',
  pluralName: 'Policies',
  publication: {
    uiForm: _form.default,
    inferredBy: [{
      classifiers: ['mule-policy', 'policy-definition']
    }, {
      classifiers: ['schema', 'metadata'],
      typeProperty: 'policy'
    }],
    files: [{
      id: 'policy',
      classifier: 'mule-policy',
      packaging: 'jar'
    }, {
      id: 'template',
      classifier: 'policy-definition',
      packaging: 'yaml'
    }, {
      id: 'schema',
      classifier: 'schema',
      packaging: 'json'
    }, {
      id: 'metadata',
      classifier: 'metadata',
      packaging: 'yaml'
    }, {
      id: 'bundle',
      classifier: 'policy-bundle',
      packaging: 'zip'
    }],
    minimumInputSets: [{
      files: ['policy', 'template']
    }, {
      files: ['schema', 'metadata']
    }],
    extensionPoints: [{
      name: 'validation'
    }, {
      name: 'legacyMetadataExtraction'
    }, {
      name: 'filesGenerator',
      config: {
        outputFileIds: ['metadata', 'schema', 'template']
      }
    }, {
      name: 'postOperation',
      timeout: 60
    }],
    ootbSteps: [{
      name: 'angModelExtraction'
    }]
  },
  portal: {
    icon: PolicyIcon,
    color: '#58595a' // steel2
  },
  keywords: ['policy']
};
var _default = exports.default = config;
//# sourceMappingURL=config.js.map